import styled from 'styled-components';
import { purple } from '../../../utils/style/colors';

export const LoadingDots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 1rem 0 0.5rem;

  & span {
    width: 10px;
    height: 10px;
    background-color: ${purple};
    border-radius: 50%;
    animation: loading-dots 1.5s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: 0s;
    }
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }

  @keyframes loading-dots {
    0%,
    80%,
    100% {
      transform: scale(0);
      opacity: 0.5;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const ThreeDotsLoading = () => {
  return (
    <LoadingDots>
      <span></span>
      <span></span>
      <span></span>
    </LoadingDots>
  );
};

export default ThreeDotsLoading;
